"use client";

import { useEffect, useId } from "react";
import PropTypes from "prop-types";
const activeInstances = new Set();
const originalStyles = {};
const BodyLock = ({
  active
}) => {
  const id = useId();
  useEffect(() => {
    const setup = () => {
      if (activeInstances.size === 0) {
        originalStyles.scrollX = globalThis.scrollX;
        originalStyles.scrollY = globalThis.scrollY;
        originalStyles.position = document.body.style.position;
        originalStyles.width = document.body.style.width;
        originalStyles.insetBlockStart = document.body.style.insetBlockStart;
        originalStyles.insetInlineStart = document.body.style.insetInlineStart;
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.insetBlockStart = `-${originalStyles.scrollY}px`;
        document.body.style.insetInlineStart = `-${Math.abs(originalStyles.scrollX)}px`;
      }
      activeInstances.add(id);
    };
    const cleanup = () => {
      activeInstances.delete(id);
      if (activeInstances.size === 0 && Object.keys(originalStyles).length !== 0) {
        document.body.style.position = originalStyles.position;
        document.body.style.width = originalStyles.width;
        document.body.style.insetBlockStart = originalStyles.insetBlockStart;
        document.body.style.insetInlineStart = originalStyles.insetInlineStart;
        try {
          globalThis.scrollTo(originalStyles.scrollX, originalStyles.scrollY);
        } catch (error) {
          error; //Add this try catch because `JSDOM` throws an error that `scrollTo` is not implemented.
        }
        for (const style in originalStyles) {
          delete originalStyles[style];
        }
      }
    };
    if (active) {
      setup();
    } else {
      cleanup();
    }
    return cleanup;
  }, [active, id]);
  return null;
};
BodyLock.propTypes = {
  /** Boolean flag to indicate if the body lock is active */
  active: PropTypes.bool
};
export default BodyLock;